import { Input } from '@/components/ui/input';
import type { ArgumentInputProps } from './types';

export function NumberInput({ arg, onChange, isError }: ArgumentInputProps) {
  const hasError = isError && arg.is_required && !String(arg.value).trim();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const num = e.target.valueAsNumber;
    onChange(Number.isNaN(num) ? '' : num);
  };

  return (
    <Input
      value={typeof arg.value === 'boolean' ? '' : arg.value}
      onChange={handleChange}
      onWheel={(e) => e.preventDefault()}
      placeholder={arg.placeholder || 'Enter number'}
      className={`h-7 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${hasError ? 'border-destructive' : ''}`}
      type="number"
      id={arg.name}
    />
  );
}
